'use client';
import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * useMap is a utility for working with a map-like (key-value pair) object stored in state. It returns `set`, `remove`, and `has` functions that will store a new object in state after applying the update. (Well, `has` won't update state, but `set` and `remove` do.)
 *
 * `useDidImmutableValueChange` stores a reference to the initial value passed in and will return true if the value has changed.
 *
 * @param {Context | undefined | null} context
 */ function useMap(initialValue = {}) {
    const [map, setMap] = React.useState(initialValue);
    const set = React.useCallback((key, val)=>{
        setMap((prevMap)=>_object_spread_props(_object_spread({}, prevMap), {
                [key]: val
            }));
    }, []);
    const remove = React.useCallback((key)=>{
        setMap((prevMap)=>{
            const clonedMap = _object_spread({}, prevMap);
            delete clonedMap[key];
            return clonedMap;
        });
    }, []);
    const has = React.useCallback((key)=>map[key] !== undefined, [
        map
    ]);
    return [
        map,
        {
            set,
            remove,
            has
        }
    ];
}

export { useMap };
